// export const serverbaselink = 'https://api.tabexseries.com';
// export const imagebaselink = 'https://ik.imagekit.io/42fa3n8bbf';

let serverbaselink = '';
let imagebaselink = '';

const hostname = window.location.hostname;
const hostnameWhttps = window.location.origin;

// Remove 'www.' if it exists
const cleanHost = hostname.startsWith('www.') ? hostname.substring(4) : hostname;

// Extract subdomain (first part before the first dot)
const subdomain = cleanHost.split('.')[0];

if (subdomain === 'dashboard' || subdomain == 'dashboardyemen') {
    serverbaselink = 'https://api.tabexseries.com';
    imagebaselink = 'https://ik.imagekit.io/42fa3n8bbf';
} else if (subdomain === 'manage') {
    serverbaselink = 'https://tabapv.site';
    imagebaselink = 'https://ik.imagekit.io/42fa3n8bbf';
} else {
    // Default fallback (local dashboard)
    // serverbaselink = 'https://api.tabexseries.com';
    serverbaselink = 'https://tabapv.site';
    imagebaselink = 'https://ik.imagekit.io/42fa3n8bbf';
}

/**
 * Tabexawy (Node AI Assistant). Chat, voice, images, eval, import, copy.
 *
 * Change AI_MODE only:
 *   'local'      → http://localhost:5050
 *   'production' → https://dasti.tabexseries.com
 *   'auto'       → local on localhost, production everywhere else
 */
const AI_MODE = 'auto';
const AI_SERVER_LOCAL = 'http://localhost:5050';
const AI_SERVER_PRODUCTION = 'https://dasti.tabexseries.com';

function resolveAiServer() {
    const mode = String(AI_MODE || 'auto').toLowerCase();
    if (mode === 'production') return AI_SERVER_PRODUCTION;
    if (mode === 'local') return AI_SERVER_LOCAL;
    const host = String(hostname || '').toLowerCase();
    if (host === 'localhost' || host === '127.0.0.1' || host === '') return AI_SERVER_LOCAL;
    return AI_SERVER_PRODUCTION;
}

const aiserverbaselink = resolveAiServer().replace(/\/$/, '');

export { hostnameWhttps, serverbaselink, imagebaselink, aiserverbaselink, AI_MODE };
